import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import { useTranslation } from 'hooks/useTranslation';

import { ConfigureIntegrations, ConnectedIntegrations } from 'screens/ManageAppScreen';
import { ErrorBoundary, VerticalNavigation } from 'components';

import Icon from 'assets/icons/';

import styles from './ManageAppScreen.module.scss';

export const ManageAppScreen = () => {
  const { t } = useTranslation();
  
  return (
    <ErrorBoundary>
      <VerticalNavigation />
      <div className={styles.content}>
        <div className={classnames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <div className={styles.container}>
              <div className={styles.headingWrap}>
                <div>
                  <NavLink className={styles.backButton} to={`/`}>
                    <Icon.ChevronThick className={styles.icon} />
                  </NavLink>
                </div>
                <div className={styles.textWrap}>
                  <div className={styles.title}>{t('manage-apps-screen.manage-apps')}</div>
                  <div className={styles.subtitle}>
                    {t('manage-apps-screen.manage-apps-subtext')}
                  </div>
                </div>
              </div>
              <ErrorBoundary>
                <ConfigureIntegrations />
                <ConnectedIntegrations />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default ManageAppScreen;

/* TODO - #32 Analytics
  this.props.tracking.trackEvent({
    event: eventTrackingNames.manageApps.view
  });
*/
